import {Modal} from "react-bootstrap";
import React, {useState, useEffect} from "react";
import RestRequest from "../../tools/RestRequest";
import config from "../../config";

export default function CurrentCity() {

    const [show, setShow] = useState(false);
    const [cities, setCities] = useState([]);
    const [current, setCurrent] = useState({city: 'Барнаул'});

    let handleShow = (e) => {
        setShow(!show);
    };

    let onChange = (e) => {
        let value = e.target.value;
        if (value.length >= 3) {
            RestRequest.all(`${config.restGeo}?&GeoSearchForm[city]=${value}`).then(data => {
                setCities(data.items);
            });
        }
    };

    let onSelectCity = (e) => {

        let city_id = parseInt(e.target.getAttribute('data-city-id'));

        if (!city_id) return false;

        let params = new FormData();
        params.append('city_id', city_id);

        RestRequest.post(`${config.restGeoCurrent}`, {
            body: params
        }).then(data => {

            if (data.id > 0) {
                setCurrent(data);
                setShow(!show);
            }
        });
    };

    useEffect(() => {

        RestRequest.all(`${config.restGeoCurrent}`).then(data => {
            setCurrent(data);
        });


        RestRequest.all(`${config.restGeo}?GeoSearchForm[is_main]=1`).then(data => {
            setCities(data.items);
        });
    }, []);

    return <>
        <div className="current-city">
            Ваш город: <span className="select-city">
                <span className="select-city__city">{current.city} </span>
                <span className="select-city__change" onClick={handleShow.bind(this)}>(изменить)</span>
            </span>
        </div>


        <Modal size="lg" show={show} onHide={handleShow.bind(this)}>
            <Modal.Header class="demo" closeButton style={{
                alignItems: 'center',
                justifyContent: 'center',
            }}>
                <form className="select-city-form">
                    <div className="select-city-form-element">
                        <input className="select-city-form__input" type="text" name="city" placeholder="Найдите свой город" onChange={onChange.bind(this)}/>
                    </div>
                </form>
            </Modal.Header>
            <Modal.Body>
                <div className="current-city-list">
                    {cities.map((el, index) => {
                        return <div key={index} className="current-city-list-item" data-city-id={el.id} onClick={onSelectCity.bind(this)}>
                            {el.city}
                        </div>
                    })}
                </div>
            </Modal.Body>
        </Modal>

    </>
}